import clsx from 'clsx';
import { type FC } from 'react';

import { Link, LinkProps } from '../Link';
import { Text, TextProps } from '../Text';

import styles from './TextLink.module.scss';

export type TextLinkProps = Omit<TextProps, 'color'> &
  Pick<LinkProps, 'href' | 'target' | 'rel' | 'isOutsideLink'> & {
    textClassName?: string;
    variant?: 'green' | 'white-50p';
  };

export const TextLink: FC<TextLinkProps> = (props) => {
  const { className, textClassName, variant = 'green', href, target, rel, isOutsideLink, ...textProps } = props;

  return (
    <Link
      className={clsx(styles.root, styles[`variant_${variant}`], className)}
      href={href}
      target={target}
      rel={rel}
      isOutsideLink={isOutsideLink}
    >
      <Text className={textClassName} {...textProps} />
    </Link>
  );
};
